export default __webpack_public_path__ + "static/media/instagram.fdd1fc5f.svg";